import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { NotificationNew } from '@thiememeulenhoff/types';
import { NotificationNewEndpointService } from './notification-new-endpoint.service';

// TODO(TLA-9320): rename once the API Gateway is migrated to the new API
@Service()
export class NotificationNewService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(NotificationNewEndpointService);

  fetchNotifications(methodSlug: string) {
    return this.#http.get<Array<NotificationNew>>(
      this.#endpoints.getNotificationsForMethod(methodSlug),
    );
  }

  postNotificationSeen(notificationId: string) {
    return this.#http.post(
      this.#endpoints.getNotificationSeen(notificationId),
      {},
    );
  }

  postNotificationAllSeen(methodSlug: string, notificationId: string) {
    return this.#http.post(this.#endpoints.getNotificationAllSeen(methodSlug), {
      notificationId,
    });
  }

  deleteNotification(notificationId: string) {
    return this.#http.delete(
      this.#endpoints.getnotificationDelete(notificationId),
    );
  }
}
